/* ============================================================
   Toee Tire - phone sticky buy bar on the product page.
   Once the real Add to Cart scrolls up out of view, a bar pinned to the
   bottom of the screen shows the price line, quantity and Add to cart.
   The bar owns no cart logic: its quantity writes the real quantity input
   (and its -/+ click the real stepper buttons), and its button clicks the
   real Add to Cart, so the theme's own form handler is the one add path.
   Visibility and layout are CSS (styles.product-bmw.css, "PMP 2"); the bar
   only renders below 768px. Pure rules are exported for
   tests/product-mobile-buybar.test.js.
   ============================================================ */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root && typeof root === 'object') root.ToeeBuyBar = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';

  /** The real button counts as sold out when it is missing or disabled. */
  function isSoldOut(button) {
    if (!button) return true;
    return !!button.disabled || !!(button.classList && button.classList.contains('disabled'));
  }

  /**
   * Show the bar whenever the real button is fully out of view — scrolled past,
   * or not reached yet (a long title can push it below the first screen). Hidden
   * while any of it is visible; a zero-height rect means it is not rendered.
   */
  function shouldShowBuyBar(state) {
    var r = state && state.buttonRect;
    if (!r || state.soldOut) return false;
    if (r.bottom - r.top <= 0) return false;
    return r.bottom <= 0 || r.top >= state.viewportHeight;
  }

  function el(doc, tag, className, text) {
    var node = doc.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  }

  function init(doc, win) {
    var page = doc.querySelector('.bmw-product-page');
    var form = page && page.querySelector('form[data-product-form]');
    var real = form && form.querySelector('button.add-to-cart');
    if (!real || !('IntersectionObserver' in win) || doc.querySelector('.toee-buybar')) return;

    var realQty = form.querySelector('input[name="quantity"]');
    var realMinus = form.querySelector('[data-quantity-decrement]');
    var realPlus = form.querySelector('[data-quantity-increment]');
    var realPrice = page.querySelector('[data-variant-price]');

    var bar = el(doc, 'div', 'toee-buybar');
    var price = el(doc, 'span', 'toee-buybar__price');
    bar.appendChild(price);

    var qty = null;
    if (realQty) {
      var group = el(doc, 'div', 'toee-buybar__qty');
      var minus = el(doc, 'button', 'toee-buybar__step', '−');
      var plus = el(doc, 'button', 'toee-buybar__step', '+');
      minus.type = plus.type = 'button';
      minus.setAttribute('aria-label', (realMinus && realMinus.getAttribute('aria-label')) || '-');
      plus.setAttribute('aria-label', (realPlus && realPlus.getAttribute('aria-label')) || '+');
      qty = el(doc, 'input', 'toee-buybar__qty-input');
      qty.type = 'number';
      qty.inputMode = 'numeric';
      qty.min = realQty.min || '1';
      if (realQty.max) qty.max = realQty.max;
      var label = form.querySelector('label[for="' + realQty.id + '"]');
      qty.setAttribute('aria-label', (label && label.textContent.trim()) || 'Quantity');
      group.appendChild(minus);
      group.appendChild(qty);
      group.appendChild(plus);
      bar.appendChild(group);

      minus.addEventListener('click', function () {
        if (realMinus) realMinus.click();
        qty.value = realQty.value;
      });
      plus.addEventListener('click', function () {
        if (realPlus) realPlus.click();
        qty.value = realQty.value;
      });
      qty.addEventListener('change', function () {
        realQty.value = qty.value;
        realQty.dispatchEvent(new win.Event('change', { bubbles: true }));
      });
    }

    var add = el(doc, 'button', 'toee-buybar__add');
    add.type = 'button';
    bar.appendChild(add);
    add.addEventListener('click', function () {
      if (qty && realQty) realQty.value = qty.value;
      real.click();
    });

    function sync() {
      add.textContent = real.textContent.trim() || 'Add to cart';
      if (qty && realQty && doc.activeElement !== qty) qty.value = realQty.value;
      var text = realPrice && realPrice.getClientRects().length ? realPrice.textContent.trim() : '';
      price.textContent = text;
      price.hidden = !text;
    }

    function update() {
      var show = shouldShowBuyBar({
        buttonRect: real.getBoundingClientRect(),
        viewportHeight: win.innerHeight,
        soldOut: isSoldOut(real),
      });
      if (show) sync();
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      bar.inert = !show;
      doc.body.classList.toggle('toee-buybar-on', show);
    }

    sync();
    update();
    doc.body.appendChild(bar);
    new win.IntersectionObserver(update).observe(real);
    if ('MutationObserver' in win) {
      new win.MutationObserver(update).observe(real, { attributes: true, attributeFilter: ['disabled', 'class'] });
    }
  }

  if (typeof document !== 'undefined' && typeof window !== 'undefined') {
    init(document, window);
  }

  return {
    isSoldOut: isSoldOut,
    shouldShowBuyBar: shouldShowBuyBar,
    init: init,
  };
});
